import { Link } from 'react-router-dom'

import styles from './Footer.module.css'

/**
 * 사이트 공통 푸터 — (주)다큐다 사업자 정보. 포비즈는 (주)다큐다 법인으로 운영한다.
 * 값 정본은 사업자등록증(주소는 2026 마포구 상암동 이전 반영).
 * 사업자 정보는 접이식(details)으로 두어 모바일에서 공간을 아낀다.
 *
 * - showNav: 소식·이용안내 링크(인증 영역 경로) 노출. 로그인 전 공개 페이지에선 false로 꺼
 *   auth로 튕기는 죽은 링크를 없앤다.
 * - bizOpen: 사업자 정보를 처음부터 펼쳐 보인다. 로그인 페이지에서 카카오 채널 검수자가
 *   클릭 없이 상호·사업자등록번호를 바로 확인하도록 쓴다.
 */
export function Footer({ showNav = true, bizOpen = false }: { showNav?: boolean; bizOpen?: boolean } = {}) {
  const year = new Date().getFullYear()
  return (
    <footer className={styles.footer}>
      <div className={styles.support}>
        <span className={styles.supportLabel}>고객센터</span>
        <a href="tel:1688-4318" className={styles.supportTel}>
          1688-4318
        </a>
        <span className={styles.supportHours}>09~21시</span>
      </div>

      {showNav && (
        <nav className={styles.links}>
          <Link to="/notices">소식</Link>
          <Link to="/guide">이용안내</Link>
        </nav>
      )}

      <details className={styles.biz} open={bizOpen}>
        <summary className={styles.bizSummary}>사업자 정보</summary>
        <dl className={styles.bizList}>
          <div>
            <dt>상호</dt>
            <dd>(주)다큐다 (대표이사 전영진)</dd>
          </div>
          <div>
            <dt>사업자등록번호</dt>
            <dd>276-88-00643</dd>
          </div>
          <div>
            <dt>통신판매업</dt>
            <dd>제2020-고양덕양-1918</dd>
          </div>
          <div>
            <dt>주소</dt>
            <dd>서울특별시 마포구 성암로 330, 5층 520호 (상암동, DMC첨단산업센터)</dd>
          </div>
          <div>
            <dt>이메일</dt>
            <dd>
              <a href="mailto:contact@daqda.kr">contact@daqda.kr</a>
            </dd>
          </div>
          <div>
            <dt>개인정보관리책임자</dt>
            <dd>임보미 (070-4283-9263)</dd>
          </div>
        </dl>
      </details>

      <p className={styles.copyright}>© {year} (주)다큐다 · 포비즈</p>
    </footer>
  )
}
